import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Blue_Outline_Btn.css'

const Blue_Outline_Btn = ({ btnText, onClick , type = "button" }) => {
    return (
        <section className="Blue_Outline_Btn_holder" >
            <Button className="Blue_Outline_Btn" type={type} onClick={onClick}>{btnText}</Button>
        </section>

    )
}

export default Blue_Outline_Btn
